/* @flow */
import Input from 'components/Input.jsx';
import Label from 'components/Label.jsx';
import React from 'react';

import cx from 'classnames';
import './styles/Radio.scss';

class Radio extends React.Component {
  static propTypes = {
    label: React.PropTypes.string,
    name: React.PropTypes.string,
    checked: React.PropTypes.bool,
    inline: React.PropTypes.bool,
    disabled: React.PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
  };

  render() {
    const { className, label, children, ...others } = this.props;
    return (
      <Label
        className={cx('Radio', {
          'Radio--inline': this.props.inline,
        }, className)}>
        <Input
          {...others}
          type="radio"
          className="Radio-input"
        />
        <span className="Radio-indicator" />
        {label}
        {children}
      </Label>
    );
  }
}

export default Radio;



// WEBPACK FOOTER //
// ./src/components/Radio.jsx